<template>
  <div class="L3">
    <div class="L3_title">
      <div class="default_title">
        <div v-show="route.icon" :style="[
          route.iconType === 'image' ? {backgroundImage: `url(.${route.icon})`, backgroundColor: 'transparent'} : {maskImage: `url(.${route.icon})`},
          route.iconSize ? route.iconSize : {}
        ]"></div>
        <div>{{route.title}}</div>
      </div><slot name="slot_title"/>
    </div>
    <div class="L3_body">
      <slot/>
    </div>
    <div class="popup" ref="popup" v-if="popup">
      <slot name="popup"/>
    </div>
  </div>
</template>

<script>
export default {
  props: ['popup'],
  data () {
    return {
      toggle: (screen.orientation.angle === 0)
    }
  },
  computed: {
    route () {
      return this.$route.meta
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.L3 {
  z-index: 10;
  min-height: 100vh;
  height: 100vh;
  max-height: 100vh;
  display: grid;
  width: 100%;
  background-color: #FFFFFF;
  grid-template-rows: 89px 1fr;
  .L3_title {
    z-index: 10;
    flex:1;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #FFFFFF;
    padding-inline: 23px 0;
    gap: 8px;
  }
  .L3_body {
    z-index: 5;
    flex:1;
    width: 100%;
    overflow-y: auto;
    height: 100%;
  }
}
</style>
<style lang="scss" scoped>
  .default_title {
    min-width: fit-content;
  }
  .L3_title {
    width: calc(100% - 66px);
    height: 89px;
    margin-inline: 22px 44px;
    border-bottom: 1px solid var(--color-fn9);
    &>div:nth-child(1) {
      height: 32px;
      display: flex;
      align-items: center;
      gap: 10px;
      z-index: 9;
      &>div:nth-child(1) {
        width: 40px;
        height: 40px;
        background-color: var(--color-pri);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        mask-position: center center;
        mask-size: contain;
        mask-repeat: no-repeat;
      }
      &>div:nth-child(2) {
        color:  var(--color-pri);
        font-size: 32px;
        font-weight: 400;
        letter-spacing: .1em;
      }
    }
    .slot_title {
      display: flex;
      margin: 0;
      margin-left: 28px;
      gap: 23px;
      height: 89px;
      width: -webkit-fill-available;
      align-items: center;
    }
  }
  .toggle {
    display: none;
  }
  .popup {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--backdrop);
    backdrop-filter: blur(5px);
    z-index: 200;
  }
</style>
